const CKEDITOR_CONFIG = {
  toolbar: [
    'heading',
    '|',
    'bold', 'italic', 'underline', 'bulletedList', 'numberedList',
    '|',
    'link', 'insertTable',
    '|',
    'undo', 'redo'
  ],
};

export default CKEDITOR_CONFIG;
